import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { METRICS, type DashMetric } from '../utils/metricConfig';

const IDS = METRICS.map((m) => m.id);

/** The selected dashboard metric lives in the URL (?metric=…) so drilldowns and back links keep it. */
export function useMetricParam(): [DashMetric, (m: DashMetric) => void] {
  const [params, setParams] = useSearchParams();
  const raw = params.get('metric');
  const metric = (IDS as string[]).includes(raw ?? '') ? (raw as DashMetric) : 'members';
  const set = useCallback(
    (m: DashMetric) => {
      const next = new URLSearchParams(params);
      if (m === 'members') next.delete('metric');
      else next.set('metric', m);
      setParams(next, { replace: true });
    },
    [params, setParams]
  );
  return [metric, set];
}
